export default __webpack_public_path__ + "static/media/top2-bg.38c26c3b.webp";